





























import { Component, Watch } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';

import PerformanceOverview from '@/componentsV2/templates/PerformanceOverview/PerformanceOverview.vue';
import PerformanceDailyMemberGrowth from '@/componentsV2/templates/PerformanceDailyMemberGrowth/PerformanceDailyMemberGrowth.vue';
import PerformanceCoinsReports from '@/componentsV2/templates/PerformanceCoinsReports/PerformanceCoinsReports.vue';
import PerformanceYourInitiatives from '@/componentsV2/templates/PerformanceYourInitiatives/PerformanceYourInitiatives.vue';
import BannerActivateBilling from '@/components/molecules/BannerActivateBilling/BannerActivateBilling.vue';

import { goToElement } from '@/utils/goToElement';
import { sleep } from '@/utils';
import { setScrollY } from '@/utils/setScrollY';

import flagKeys from '@/constants/flagKeys';
import BillingModel from '@/views/Models/BillingModel.vue';
import { EBillingStatusTypes } from '@/store/modules/businessTypes';

@Component({
  components: {
    Page,
    PerformanceOverview,
    PerformanceCoinsReports,
    PerformanceYourInitiatives,
    PerformanceDailyMemberGrowth,
    BannerActivateBilling
  }
})
export default class Overview extends BillingModel {
  shouldhHighlightedCard = false;

  get gaEventPage() {
    return 'Performance Overview';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get reportType() {
    return this.businessInfo.reportType;
  }

  get tPrefixBilling() {
    return 'performance.billing';
  }

  get showActivateBillingBanner() {
    return this.billingStatus === EBillingStatusTypes.UNSUBSCRIBED;
  }

  get descriptionActivateBilling() {
    return this.$t(`${this.tPrefixBilling}.bannerDescription`);
  }

  get showCoinsReports() {
    return this.reportType.includes('coin');
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get editCustomerInactivityIsEnabled() {
    return this.flags.includes(flagKeys.editCustomerInactivity);
  }

  mounted() {
    this.checkShowTutorial();
  }

  async checkShowTutorial() {
    if (!this.editCustomerInactivityIsEnabled) return;

    const containerScrollSelector = '.container-scrollable';

    setScrollY(containerScrollSelector, 'hidden');
    await sleep(1000);
    setScrollY(containerScrollSelector, 'auto');

    this.shouldhHighlightedCard = true;
  }

  @Watch('$route')
  goToSection() {
    const anchorHash = this.$route.hash;

    goToElement(anchorHash);
  }
}
